// Metadados de apresentação para as dimensões de governança do Data Lake Launches
// (LOOP S / Fase 5B). READ-ONLY: só mapeia códigos do banco -> rótulo + cor.
// Fonte dos vocabulários: empreendimento_tipologias.use_category (CHECK:
// residential|office|retail|logistics|industrial|parking|unknown) e .product_type.

export const USE_META = {
  residential: { label: 'Residencial',     color: 'bg-emerald-100 text-emerald-700' },
  office:      { label: 'Office',           color: 'bg-sky-100 text-sky-700' },
  retail:      { label: 'Loja/Varejo',      color: 'bg-amber-100 text-amber-700' },
  logistics:   { label: 'Logística',        color: 'bg-indigo-100 text-indigo-700' },
  industrial:  { label: 'Industrial',       color: 'bg-slate-200 text-slate-700' },
  parking:     { label: 'Vagas',            color: 'bg-zinc-100 text-zinc-600' },
  unknown:     { label: 'Não classificado', color: 'bg-slate-100 text-slate-500' },
};

export const PRODUCT_LABEL = {
  apartment:       'Apartamento',
  studio:          'Studio',
  penthouse:       'Cobertura',
  garden:          'Garden',
  office:          'Sala',
  corporate_floor: 'Laje corporativa',
  retail_store:    'Loja',
  warehouse:       'Galpão',
};

// Fallback para USE_META.unknown quando o código vem null/desconhecido do banco.
// NB: nas telas usamos `USE_META[code] ?? USE_META.unknown` inline dentro dos
// .map() (evita o lint react-hooks/rules-of-hooks com o prefixo `use`); este
// helper existe para chamadas fora de callbacks e para consumidores futuros.
export const useMeta = (code) => USE_META[code] ?? USE_META.unknown;

// Badges auxiliares (classes Tailwind) reutilizados nas duas telas.
export const MIXED_BADGE = 'bg-violet-100 text-violet-700';
export const REVIEW_BADGE = 'bg-red-50 text-red-700';
export const FLEX_BADGE = 'bg-amber-50 text-amber-700';
